import React from 'react';

import { t } from '@grafana/i18n';
import { EmptyState, TextLink } from '@grafana/ui';

import { PATTERNS_MAX_AGE_HOURS } from './PatternsBreakdownScene';

export const PatternsNotConfigured = () => {
  return (
    <EmptyState
      variant="not-found"
      message={t('components.service-scene.breakdowns.patterns.patterns-not-detected.error-title', 'There are no pattern matches.')}
    >
      {t(
        'components.service-scene.breakdowns.patterns.patterns-not-detected.error-message',
        'Pattern matching has not been configured. Patterns let you detect similar log lines and add or exclude them from your search. To see them in action, add the following to your Loki configuration.'
      )}
      <p>
        {/* eslint-disable-next-line @grafana/i18n/no-untranslated-strings -- Loki config flag literal */}
        <code>--pattern-ingester.enabled=true</code>
      </p>
    </EmptyState>
  );
};

export const PatternsNotDetected = () => {
  return (
    <EmptyState
      variant="not-found"
      message={t(
        'components.service-scene.breakdowns.patterns.patterns-not-detected.not-detected-title',
        'Sorry, we could not detect any patterns.'
      )}
    >
      <p>
        {t(
          'components.service-scene.breakdowns.patterns.patterns-not-detected.not-detected-help-prefix',
          'Check back later or reach out to the team in the'
        )}{' '}
        <TextLink href="https://slack.grafana.com/" external>
          {t('components.service-scene.breakdowns.patterns.patterns-not-detected.not-detected-help-link', 'Grafana Labs community Slack channel')}
        </TextLink>
        .{' '}
        {t(
          'components.service-scene.breakdowns.patterns.patterns-not-detected.not-detected-description',
          'Patterns let you detect similar log lines to include or exclude from your search.'
        )}
      </p>
    </EmptyState>
  );
};

export const PatternsNoMatchingFilters = () => {
  return (
    <EmptyState
      variant="not-found"
      message={t('components.service-scene.breakdowns.patterns.patterns-not-detected.no-match-filters-title', 'No patterns match these filters.')}
    />
  );
};

export const PatternsTooOld = () => {
  return (
    <EmptyState
      variant="not-found"
      message={t(
        'components.service-scene.breakdowns.patterns.patterns-not-detected.too-old-title',
        'Patterns are only available for the most recent {{maxAgeHours}} hours of data.',
        { maxAgeHours: PATTERNS_MAX_AGE_HOURS }
      )}
    >
      <p>
        {t('components.service-scene.breakdowns.patterns.patterns-not-detected.too-old-docs-prefix', 'See the')}{' '}
        <TextLink href="https://grafana.com/docs/grafana/latest/explore/simplified-exploration/logs/patterns/" external>
          {t('components.service-scene.breakdowns.patterns.patterns-not-detected.too-old-docs-link', 'patterns docs')}
        </TextLink>{' '}
        {t('components.service-scene.breakdowns.patterns.patterns-not-detected.too-old-docs-suffix', 'for more info.')}
      </p>
    </EmptyState>
  );
};
